import { httpGet } from '../utils'

export default {
  getList (cb, { roleId, tagId, orgId, page, perPage, withRelation }) {
    if (roleId) {
      httpGet(`/api/contact?page=${page}&per_page=${perPage}&order_by=id&role_id=${roleId}&with=${withRelation}`, cb)
    } else if (tagId) {
      httpGet(`/api/contact?page=${page}&per_page=${perPage}&order_by=id&tag_id=${tagId}&with=${withRelation}`, cb)
    } else if (orgId) {
      httpGet(`/api/contact?page=${page}&per_page=${perPage}&order_by=id&org_id=${orgId}&with=${withRelation}`, cb)
    } else {
      httpGet(`/api/contact?page=${page}&per_page=${perPage}&order_by=id&with=${withRelation}`, cb)
    }
  },
  getContact (cb, id) {
    httpGet(`/api/contact/${id}`, cb)
  },
  getContactNote (cb, id) {
    httpGet(`/api/contact/${id}/note`, cb)
  },
  getContactNoteStat (cb, id) {
    httpGet(`/api/contact/${id}/note/statistics`, cb)
  },
  getContactAttachment (cb, id) {
    httpGet(`/api/contact/${id}/attachment`, cb)
  },
  getContactAttachmentStat (cb, id) {
    httpGet(`/api/contact/${id}/attachment/statistics`, cb)
  },
  getContactFormfills (cb, { id, page, perPage }) {
    httpGet(`/api/contact/${id}/formfill?page=${page}&per_page=${perPage}&order_by=id`, cb)
  },
  getContactSignups (cb, { id, page, perPage }) {
    httpGet(`/api/contact/${id}/signup?page=${page}&per_page=${perPage}&order_by=id`, cb)
  },
  getContactDonates (cb, { id, page, perPage }) {
    httpGet(`/api/contact/${id}/donate?page=${page}&per_page=${perPage}&order_by=id`, cb)
  },
  getContactDonateStat (cb, id) {
    httpGet(`/api/contact/${id}/donate/statistics`, cb)
  },
  getOrg (cb, { orgId, contactId }) {
    if (orgId) {
      httpGet(`/api/org/${orgId}`, cb)
    } else if (contactId) {
      httpGet(`/api/contact/${contactId}?with=org`, cb)
    }
  },
  getTaggedList (cb, tag) {
    setTimeout(() => { cb.success() }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/contact.js